import { FlowDeviceConfig } from './useFlowConfig';
import { FlowDeviceConfigHistory, FlowDeviceLog } from './useFlowConfigHistory';

export function getBaseAlertMessageString(
  config: FlowDeviceConfig,
  type: 'tempAlert' | 'belowLimit' | 'tempAlertMax'
) {
  if (type === 'tempAlertMax' && config.temp?.alertMax) {
    return `Varme alarm ved: ${config.temp.alertMax} grader. Nulstiller ved: over ${config.temp.resetMax} grader`;
  }
  if (type === 'tempAlert' && config.temp?.alert) {
    return `Frost alarm ved: ${config.temp.alert} grader. Nulstiller ved: over ${config.temp.reset} grader`;
  }
  if (type === 'belowLimit' && config.cmLimit) {
    return `Lav beholding i beholder ved: ${config.cmLimit}cm`;
  }
  return '';
}

export function getExtendedAlertMessageString(
  configHistory: FlowDeviceConfigHistory,
  type: 'tempAlert' | 'belowLimit'
): string {
  const baseMessage = getBaseAlertMessageString(configHistory.config, type);
  const log = configHistory.log;

  if (type === 'belowLimit') {
    return `${baseMessage}.\nNiveau i beholder: ${log.cm}cm ved log tidspunkt`;
  }
  if (type === 'tempAlert') {
    const logType = log as FlowDeviceLog;
    return `${baseMessage}.\nLog: ${logType.Te} grader ved log tidspunkt`;
  }
  if (type === 'tempAlertMax') {
    const logType = log as FlowDeviceLog;
    return `${baseMessage}.\nLog: ${logType.Te} grader ved log tidspunkt`;
  }
  return baseMessage;
}
